module.exports = __webpack_public_path__ + "img/melee.d95dac7a.svg";